module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', [_c('span', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("These are the top three cards in the deck")]), _c('v-layout', {
    attrs: {
      "align-center": "",
      "pl-3": ""
    }
  }, _vm._l((_vm.action.learned), function(card, i) {
    return _c('policy-card', {
      key: i,
      staticClass: "card",
      attrs: {
        "policy": card
      }
    })
  })), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.complete()
      }
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-55a730ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/EXECUTIVE_ACTION/actions/preview-deck.vue
// module id = 328
// module chunks = 0